var map = {
	"./banana-active.png": 64299,
	"./del-active.png": 1599,
	"./goods-active.png": 11952,
	"./mannequin-active.png": 6298,
	"./real-active.png": 86262,
	"./tabularasa-active.png": 51414,
	"./texture-active.png": 20773,
	"./vip-active.png": 95277,
	"./wig-active.png": 52883
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39331;